<template>
  <div>
    <div v-if="$route.path.indexOf('_detail') === -1">
      <el-row>
        <el-col :md="6" :lg="6">
          <el-input placeholder="订单号" v-model="order_id" clearable @clear="keywordsSearch" @keyup.enter.native="keywordsSearch" size="mini">
            <el-button slot="append" icon="el-icon-search" @click="keywordsSearch"></el-button>
          </el-input>
        </el-col>
        <el-col :md="6" :lg="6">
          <el-input placeholder="货号(多货号用英文,隔开，如：1234,5678)" v-model="sku_bn" clearable @clear="keywordsSearch" @keyup.enter.native="keywordsSearch" size="mini">
            <el-button slot="append" icon="el-icon-search" @click="keywordsSearch"></el-button>
          </el-input>
        </el-col>
        <el-col :md="6" :lg="6">
          <el-input placeholder="推广者账号" v-model="sharer_mobile" clearable @clear="keywordsSearch" @keyup.enter.native="keywordsSearch" size="mini">
            <el-button slot="append" icon="el-icon-search" @click="keywordsSearch"></el-button>
          </el-input>
        </el-col>
      </el-row>
      <el-row>
        <el-col :md="12" :lg="12">
          <el-date-picker v-model="created" type="datetimerange" align="right" unlink-panels range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" :picker-options="pickerOptions" @change="dateChange" format="yyyy-MM-dd HH:mm:ss"
                          value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']" size="mini">
          </el-date-picker>
<!--          <el-button size="mini" type="primary" @click="exportData" v-loading="exportLoading" v-if="exportLoading == false">导出</el-button>-->
<!--          <el-button size="mini" type="primary" v-loading="exportLoading" element-loading-text="拼命导出中..." v-else>导出</el-button>-->
          <el-button size="mini" type="primary" @click="exportViewOpen2">以结算时间为准导出</el-button>
          <el-button size="mini" type="primary" @click="exportViewOpen" v-loading="exportLoading" v-if="exportLoading == false">导出</el-button>
          <el-button size="mini" type="primary" v-loading="exportLoading" element-loading-text="拼命导出中..." v-else>导出</el-button>
          <el-popover
            placement="top-start"
            width="200"
            trigger="hover"
            content="导出任务会以队列执行，点击导出后，请至‘设置-导出列表-优选订单’页面中查看及下载数据">
            <i class="el-icon-question" slot="reference"></i>
          </el-popover>
        </el-col>
      </el-row>
      <el-dialog title="报表下载" :visible.sync="downloadView" :close-on-click-modal="false">
        <template v-if="downloadUrl">
          <a :href="downloadUrl" download>{{downloadName}}</a>
        </template>
      </el-dialog>

      <el-dialog title="报表设置" :visible.sync="exportView" :close-on-click-modal="false">
        <el-form>
        <el-form-item label-width="100px" label="报表名称">
          <el-input v-model="exportTitle" placeholder="报表名称"></el-input>
        </el-form-item>
        <el-form-item class="content-center">
          <el-button size="mini" type="primary" @click="exportData" v-loading="exportLoading" v-if="exportLoading == false">导出报表</el-button>
          <el-button size="mini" type="primary" v-loading="exportLoading" element-loading-text="拼命导出中..." v-else>导出报表</el-button>
        </el-form-item>
        </el-form>
      </el-dialog>

      <div class="recharge-overview view-flex content-center content-padded" style="width: 40%;">
        <div class="view-flex-item">
          <i class="iconfont icon-donate"></i>
          <div><span>订单金额</span> <span class="money mark">{{orderTongji.yborderPrice}}</span> </div>
        </div>
        <div class="view-flex-item">
          <!--            <i class="iconfont icon-credit-card1"></i>-->
          <i class="iconfont icon-clipboard-list"></i>
          <div>订单数 <span class="money mark">{{orderTongji.yborderCount}}</span> </div>
        </div>
        <div class="view-flex-item">
          <i class="iconfont icon-dolly-flatbed"></i>
          <div><span>销售数</span> <span class="money mark">{{orderTongji.goodsNum}}</span> </div>
        </div>
      </div>

      <el-table :data="ybordersData" :height="wheight-210"  v-loading="loading"  @selection-change="handleSelectionChange">
<!--        <el-table-column type="selection" align="center" label="全选"></el-table-column>-->
<!--        <el-table-column prop="id" label="ID" width="50"></el-table-column>-->
        <el-table-column prop="order_id" label="订单号" width="170"></el-table-column>
<!--        <el-table-column prop="goods_id" label="商品ID" width="100"></el-table-column>-->
        <el-table-column prop="bn" label="商品货号" width="80"></el-table-column>
        <el-table-column prop="name" label="商品名称" width="130"></el-table-column>
        <el-table-column prop="nums" label="数量" width="50"></el-table-column>
        <el-table-column prop="nums" label="自定义佣金" width="70">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.is_rate_custom == 1">否</el-tag>
            <el-tag v-else type="danger">是</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="pcate_name" label="推类名称" width="60"></el-table-column>
        <el-table-column prop="pcate_ratio" label="推类佣金比例" width="70"></el-table-column>
        <el-table-column prop="count_rate" label="最终佣金比例" width="70"></el-table-column>
        <el-table-column prop="price" label="实际销售单价" width="70"></el-table-column>
<!--        <el-table-column prop="billing_payed" label="结算金额" width="130"></el-table-column>-->
        <el-table-column prop="amount" label="总金额" width="70"></el-table-column>
        <el-table-column prop="total_commission" label="佣金" width="70"></el-table-column>
        <el-table-column prop="order_status" label="订单状态" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.order_status=='100'">已支付</el-tag>
            <el-tag v-else-if="scope.row.order_status=='105'" type="danger">退款中</el-tag>
            <el-tag v-else-if="scope.row.order_status=='110'" type="info">已退款</el-tag>
            <el-tag v-else-if="scope.row.order_status=='120'" type="warning">已支付已发货</el-tag>
            <el-tag v-else-if="scope.row.order_status=='130'" type="danger">已支付已退货</el-tag>
            <el-tag v-else-if="scope.row.order_status=='140'" type="info">已退货已退款</el-tag>
            <el-tag v-else-if="scope.row.order_status=='150'" type="success">已成交</el-tag>
            <el-tag v-else-if="scope.row.order_status=='160'" type="info">已作废</el-tag>
            <el-tag v-else-if="scope.row.order_status=='170'" type="info">已分佣</el-tag>
            <el-tag v-else-if="scope.row.order_status=='180'" type="info">分佣已停止</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="billing_status" label="结算状态" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.billing_status=='1'">已结算</el-tag>
            <el-tag v-else-if="scope.row.billing_status=='2'" type="info">结算失败</el-tag>
            <el-tag v-else type="danger">未结算</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="member_id" label="购买者B2C会员ID" width="100"></el-table-column>
        <el-table-column prop="mobile" label="购买者账号" width="120"></el-table-column>
        <el-table-column prop="user_id" label="推广者怡贝会员ID" width="100"></el-table-column>
        <el-table-column prop="sharer_mobile" label="推广者账号" width="120"></el-table-column>
        <el-table-column prop="sharer_name" label="推广者姓名" width="100"></el-table-column>
        <el-table-column prop="store_name" label="店铺名称" width="100"></el-table-column>
        <el-table-column prop="number" label="英克ID" width="70"></el-table-column>
        <el-table-column prop="send_type" label="配送类型" width="80"></el-table-column>
        <el-table-column prop="is_fb" label="佣金翻倍" width="60">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.is_fb=='true'">是</el-tag>
            <el-tag v-else type="danger">否</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="yb_createtime_date" label="下单时间" width="170"></el-table-column>
        <el-table-column prop="updated_date" label="更新时间" width="170"></el-table-column>
      </el-table>
      <div v-if="total_count > params.pageSize" class="content-padded tc">
        <el-pagination background   layout="prev, pager, next, total" @current-change="handleCurrentChange" :current-page.sync="params.page" :total='total_count' :page-size='params.pageSize'>
        </el-pagination>
      </div>

    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import {getYbordersList, getOrderTongji, ybordersExport} from '../../../api/sharer'
import Style from "../../pc/footerPage/components/plugins/footer/style";
import {mapGetters} from "vuex";
export default {
  components: {Style},
  data () {
    return {
      total_count: 0,
      loading: false,
      exportLoading: false,
      ybordersData: [],
      orderTongji: '',
      params: {
        page: 1,
        pageSize: 20
      },
      exportTitle: '优选订单' + new Date().getTime(),
      exportView: false,
      downloadView: false,
      downloadUrl: '',
      downloadName: '',
      order_id: '',
      sku_bn: '',
      sharer_mobile: '',
      created: '',
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },
  computed: {
    // 默认时间
    timeDefault () {
      let date = new Date()
      // 通过时间戳计算
      let defalutStartTime = date.getTime() - 7 * 24 * 3600 * 1000 // 转化为时间戳
      let defalutEndTime = date.getTime()
      let startDateNs = new Date(defalutStartTime)
      let endDateNs = new Date(defalutEndTime)
      // 月，日 不够10补0
      defalutStartTime = startDateNs.getFullYear() + '-' + ((startDateNs.getMonth() + 1) >= 10 ? (startDateNs.getMonth() + 1) : '0' + (startDateNs.getMonth() + 1)) + '-' + (startDateNs.getDate() >= 10 ? startDateNs.getDate() : '0' + startDateNs.getDate())
      defalutEndTime = endDateNs.getFullYear() + '-' + ((endDateNs.getMonth() + 1) >= 10 ? (endDateNs.getMonth() + 1) : '0' + (endDateNs.getMonth() + 1)) + '-' + (endDateNs.getDate() >= 10 ? endDateNs.getDate() : '0' + endDateNs.getDate())
      this.params.time_start_begin = this.dateStrToTimeStamp(defalutStartTime + ' 00:00:00')
      this.params.time_start_end = this.dateStrToTimeStamp(defalutEndTime + ' 23:59:59')
      this.getItems(this.params)
      return [defalutStartTime, defalutEndTime]
    },
    ...mapGetters([
      'wheight'
    ])
  },
  created () {
    this.created = this.timeDefault
  },
  methods: {
    getItems (filter) {
      console.log(filter)
      this.loading = true
      this.getOrderTongji(filter)
      getYbordersList(filter).then(response => {
        this.ybordersData = response.data.data.list
        this.total_count = Number(response.data.data.total_count)
        this.loading = false
        this.exportLoading = false
      })
    },
    getOrderTongji (filter) {
      // this.loading = true
      getOrderTongji(filter).then(response => {
        this.orderTongji = response.data.data
        // this.loading = false
      })
    },
    handleCurrentChange (val) {
      this.params.page = val
      this.getItems(this.params)
    },
    handleSelectionChange (val) {
      console.log(val)
    },
    getParams () {
      this.params.order_id = this.order_id
      this.params.sku_bn = this.sku_bn
      this.params.sharer_mobile = this.sharer_mobile
      this.params.exportTitle = this.exportTitle
    },
    dateChange (val) {
      console.log(val)
      if (val && val.length > 0) {
        // this.params.time_start_begin = this.dateStrToTimeStamp(val[0] + ' 00:00:00')
        // this.params.time_start_end = this.dateStrToTimeStamp(val[1] + ' 23:59:59')
        this.params.time_start_begin = this.dateStrToTimeStamp(val[0])
        this.params.time_start_end = this.dateStrToTimeStamp(val[1])
      } else {
        this.params.time_start_begin = ''
        this.params.time_start_end = ''
      }
      this.params.page = 1
      // console.log(this.params)
      this.getItems(this.params)
    },
    dateStrToTimeStamp (str) {
      return Date.parse(new Date(str)) / 1000
    },
    keywordsSearch (e) {
      this.params.page = 1
      this.getParams()
      this.getItems(this.params)
    },
    exportViewOpen2 () {
      this.params.isdone = true
      this.exportView = true
      this.exportTitle = '优选订单(结算时间)' + new Date().getTime()
    },
    exportViewOpen () {
      this.params.isdone = false
      this.exportView = true
      this.exportTitle = '优选订单' + new Date().getTime()
    },
    exportData () {
      this.getParams()
      this.exportLoading = true
      this.exportView = false
      ybordersExport(this.params).then(response => {
        this.exportLoading = false
        if (response.data.status) {
          this.$message({
            type: 'success',
            message: '已加入执行队列，请在设置-导出列表-优选订单中下载'
          })
          return
        } else if (response.data.url) {
          this.downloadUrl = response.data.url
          this.downloadName = response.data.filename
          this.downloadView = true
        } else {
          this.$message({
            type: 'error',
            message: '无内容可导出 或 执行失败，请检查重试'
          })
          return
        }
      })
    }
  },
  mounted () {
    this.getItems(this.params)
  },
  watch: {
    // 分页全选-监听数据变化
    ybordersData: {
      handler (value) {
        if (this.allCheck) {
          this.ybordersData.forEach(row => {
            if (row) {
              this.$refs.multipleTable.toggleRowSelection(row, true)
            }
          })
        }
      },
      deep: true
    }
  }
}
</script>
<style type="text/css">
.el-col{
  padding-left: 10px;
  padding-right: 10px;
}
</style>
<style scoped lang="scss">
.recharge-overview {
  .iconfont {
    font-size: 30px;
    color: #ff5000;
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// list.vue?6726fcb6